import React, { useState, useEffect } from "react";
import StackPage from "./StackPage";
import {
  Box,
  Rating,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import StarIcon from "@mui/icons-material/Star";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useNavigate } from "react-router-dom";
import CategoryIcon from "@mui/icons-material/Category";
import api from "../../api/api";
import { ToastContainer, toast } from "react-toastify";

const question_type_dom = (stack) => {
  if (stack.answerType === "textfield")
    return (
      <div>
        <TextField fullWidth />
      </div>
    );
  else if (stack.answerType === "textarea")
    return (
      <div>
        <TextField multiline rows={4} fullWidth />
      </div>
    );
  else if (stack.answerType === "radio")
    return (
      <div>
        <FormGroup>
          {stack.allottedOption.map((option, index) => (
            <FormControlLabel
              key={index}
              control={<Radio />}
              label={option.value}
            />
          ))}
        </FormGroup>
      </div>
    );
  else if (stack.answerType === "checkbox")
    return (
      <div>
        <FormGroup>
          {stack.allottedOption.map((option, index) => (
            <FormControlLabel
              key={index}
              control={<Checkbox />}
              label={option.value}
            />
          ))}
        </FormGroup>
      </div>
    );
  else if (stack.answerType === "select")
    return (
      <div>
        <FormControl fullWidth>
          <InputLabel>Select Option</InputLabel>
          <Select label="Select Option">
            {stack.allottedOption.map((option, index) => (
              <MenuItem>{option.value}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  else if (stack.answerType === "rating")
    return (
      <div>
        <Rating precision={0.5} emptyIcon={<StarIcon fontSize="inherit" />} />
      </div>
    );
  else if (stack.answerType === "date")
    return (
      <div>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker />
        </LocalizationProvider>
      </div>
    );
  else if (stack.answerType === "time")
    return (
      <div>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TimePicker />
        </LocalizationProvider>
      </div>
    );
  else return <div></div>;
};

const FormTemplatePage = ({
  open,
  editData,
  onSave,
  onClose,
  form_save_button_on_click,

  updateTemplate,
}) => {
  const form_data = {};
  const navigate = useNavigate();

  // ----------------------------- Title ------------------------------
  const [titleIsEditing, setTitleIsEditing] = useState(false);
  const [formTitle, setFormTitle] = useState("Untitled Form");

  // ------------------------------------------------------------------

  // ----------------------------- Description ------------------------------
  const [descriptionIsEditing, setDescriptionIsEditing] = useState(false);
  const [formDescription, setFormDescription] = useState("Form Description");
  const [submitAction, setSubmitAction] = useState("save");
  const [formId, setFormId] = useState("");

  // ------------------------------------------------------------------

  // ----------------------------- Stacks -----------------------------

  const [stackData, setStackData] = useState([]);

  const [showStackDialog, setShowStackDialog] = useState(false);
  const add_stack = () => {
    if (editData) {
      setShowStackDialog(true);
      setSubmitAction("update");
    } else {
      setShowStackDialog(true);
      setSubmitAction("save");
    }
    // setShowStackDialog(true);
    // setSubmitAction("save");
  };
  const stack_dialog_on_close = () => {
    setShowStackDialog(false);
  };
  const remove_stack = (indexToRemove) => {
    setStackData((prevStack) =>
      prevStack.filter((_, index) => index !== indexToRemove)
    );
  };
  const get_stack_data = (stack) => {
    console.log("-->stack: ", stack);
    setStackData((prev_stack) => [...prev_stack, stack]);
    stack_dialog_on_close();
    // onClose();
  };
  const change_stack_position = (startIndex, endIndex) => {
    const newData = [...stackData];
    const [movedElement] = newData.splice(startIndex, 1); // Remove the element from its current position
    newData.splice(endIndex, 0, movedElement); // Insert the element at the new position
    setStackData(newData);
  };
  // ------------------------------------------------------------------

  // ------------------------------ Form Submit -----------------------

  // ------------------------------------------------------------------

  const handleFormSubmit = () => {
    if (submitAction === "update") {
      const updatedData = {
        // ...editData,
        surveyId: formId,
        surveyDescription: formDescription,
        surveyName: formTitle,
        surveyData: stackData,
        usertype: "fellow",
      };

      console.log("updatedData------------->", updatedData);
      console.log("updatedData2------------->", formTitle, formDescription);
      // Call the update function here
      updateTemplate(updatedData);
    } else if (submitAction === "save") {
      form_save_button_on_click(stackData, formTitle, formDescription);
    }
  };

  useEffect(() => {
    if (editData) {
      console.log("editData", editData);
      setStackData([...editData.surveyData]);
      setSubmitAction("update");
      setFormTitle(editData.surveyName);
      setFormDescription(editData.surveyDescription);
      setFormId(editData.surveyId);
    } else {
      setSubmitAction("save");
    }
  }, [editData]);

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogContent>
        <div className="form-container">
          {/* Form Title */}
          <div className="fixed-div">
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <div onClick={() => setTitleIsEditing(true)}>
                  {titleIsEditing ? (
                    <TextField
                      fullWidth
                      value={formTitle}
                      onChange={(e) => {
                        setFormTitle(e.target.value);
                      }}
                      onBlur={(e) => setTitleIsEditing(false)}
                      autoFocus
                    />
                  ) : (
                    <h2>{formTitle}</h2>
                  )}
                </div>
                <div onClick={() => setDescriptionIsEditing(true)}>
                  {descriptionIsEditing ? (
                    <TextField
                      fullWidth
                      value={formDescription}
                      onChange={(e) => {
                        setFormDescription(e.target.value);
                      }}
                      onBlur={(e) => setDescriptionIsEditing(false)}
                      autoFocus
                    />
                  ) : (
                    <h5>{formDescription}</h5>
                  )}
                </div>
              </Grid>
              <Grid item xs={4}>
                <Button onClick={handleFormSubmit} className="float-right">
                  {submitAction === "save" ? "Save" : "Update"}
                </Button>
                <Button
                  onClick={onClose}
                  color="primary"
                  className="float-right"
                >
                  X
                </Button>
                <Button
                  variant="contained"
                  onClick={add_stack}
                  startIcon={<AddCircleOutlineIcon />}
                  className="float-right"
                >
                  Add Form Element
                </Button>
              </Grid>
            </Grid>
          </div>
          {/* Stacks */}
          <div className="scrollable-div">
            <div className="cards-container">
              {stackData.map((stack, index) => (
                <Card key={index} sx={{ width: "50%", marginBottom: 4 }}>
                  <CardHeader
                    action={
                      <>
                        <IconButton
                          aria-label="delete"
                          onClick={() =>
                            change_stack_position(index, index + 1)
                          }
                        >
                          <KeyboardArrowDownIcon />
                        </IconButton>
                        <IconButton
                          aria-label="delete"
                          onClick={() =>
                            change_stack_position(index, index - 1)
                          }
                        >
                          <KeyboardArrowUpIcon />
                        </IconButton>
                        <IconButton
                          aria-label="delete"
                          onClick={() => remove_stack(index)}
                        >
                          <CloseIcon />
                        </IconButton>
                      </>
                    }
                    title={`${index + 1}.${stack.question}`}
                  />
                  <CardContent>{question_type_dom(stack)}</CardContent>
                </Card>
              ))}
            </div>
          </div>

          <StackPage
            open={showStackDialog}
            onSave={get_stack_data}
            onClose={stack_dialog_on_close}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FormTemplatePage;
